const CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

/**
 * Generates a cryptographically random alphanumeric password.
 */
export function generateRandomPassword(length = 12): string {
	const values = new Uint8Array(length);
	crypto.getRandomValues(values);
	return Array.from(values, (v) => CHARSET[v % CHARSET.length]).join("");
}
